module.exports = __webpack_public_path__ + "assets/3f8509b79d5bff94a3e2b904cf1234cf.png";